import Button from 'components/base/Button';
import { Col, Form, Row, Toast, ToastContainer } from 'react-bootstrap';

import { useAuth } from 'providers/AuthProvider'
import { useState, useEffect, FormEvent } from 'react';
import apiClient, { handleAPIError } from 'helpers/apiService';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import CourseForm from './components/CourseForm';
import ImageUpload from 'components/common/ImageUpload';
import { Course } from '../my_learning/components/DataDefinitions';


const UpdateCourse = () => {

    const { t } = useTranslation();

    const breadcrumbItems: PageBreadcrumbItem[] = [
        {
            label: t('Dashboard'),
            url: '/dashboard/home'
        },
        {
            label: t('Courses'),
            url: '/admin/courses'
        },
        {
            label: t('Add Course'),
            active: true
        }
    ];

    const navigate = useNavigate();

    const auth = useAuth();

    // Route parameters
    const { course_id } = useParams();

    // State to store the form data from all child components
    const [formData, setFormData] = useState<any>({ 'courseForm': '', 'notes': '', 'image': null });

    // State to store existing contact data before update
    const [initialData, setInitialData] = useState<Course>();
    const [loading, setLoading] = useState(true);

    // State to control Toast messages
    const [show, setShow] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const onChangeCourseImage = (image: File | null) => {
        if (image) {
            setFormData({ ...formData, ['image']: image });
        }
    };

    // Function to handle form data update from child components
    const updateFormData = (name: string, data: any) => {
        setFormData({ ...formData, [name]: data });
    };

    const handleSumbit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();


        const form = new FormData();
        form.append('courseForm', JSON.stringify(formData['courseForm']));
        //form.append('notes', formData['notes']);
        form.append('file', formData['image']);


        try {
            const response = await apiClient.put(
                `/v1/courses/${course_id}`, form,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',

                    }
                }
            );
            setToastMessage(response.data['message'])
            setShow(true);
        } catch (error) {
            console.error('Request failed:', error);
        }

    };

    const fetchCourse = async () => {
        try {
            const response = await apiClient.get(
                `/v1/courses/${course_id}`,
                {
                    headers: {
                        'accept': 'application/json',

                    },
                    withCredentials: true,
                }
            );

            console.log(response.data);
            setInitialData(response.data);
            const image = response.data.picture ? `data:image/jpeg;base64, ${response.data.picture}` : null;
            formData.courseForm = response.data;
            setFormData({ ...formData, ['image']: image });
        } catch (error) {
            console.error('Error fetching course data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCourse();
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <div className="mb-9">
            <div>
                <ToastContainer className="p-3" position='top-center'>
                    <Toast onClose={() => { setShow(false); navigate(-1); }} show={show} delay={3000} autohide>
                        <Toast.Body className=''>{toastMessage}</Toast.Body>
                    </Toast>
                </ToastContainer>
            </div>

            <PageBreadcrumb items={breadcrumbItems} />
            <Form onSubmit={handleSumbit}>
                <div className="border-bottom mb-7 mx-n3 px-2 mx-lg-n6 px-lg-6">
                    <Row>
                        <Col xl={12}>
                            <div className="d-sm-flex justify-content-between">
                                <h2 className="mb-4">{t('UpdateCourse.edit_course')}</h2>
                                <div className="d-flex mb-3">
                                    <Button variant="phoenix-primary" className="me-2 px-6" onClick={() => navigate(-1)} >
                                        {t('Back')}
                                    </Button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>

                <Row>
                    <Col sm={12} md={12} >
                        <CourseForm onUpdate={data => updateFormData('courseForm', data)} initialData={initialData} className="mb-6" />
                    </Col>
                    <Col sm={12} md={12} >
                        <Row><h4 className="mb-3">Course Image (best w:350 h:200)</h4></Row>
                        <Row>
                            <ImageUpload src={formData['image'] ? formData['image'] : null} onChange={onChangeCourseImage} className='image-uploader-320h' />
                        </Row>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <div className="text-end">
                            <Button type="submit" variant="primary" className='mt-2'>Save course</Button>
                        </div>
                    </Col>
                </Row>

            </Form>
        </div>
    );

};

export default UpdateCourse;
